import { render, staticRenderFns } from "./LandingViewTemplate.vue?vue&type=template&id=7b2899a7&scoped=true&"
import script from "./LandingViewTemplate.vue?vue&type=script&lang=js&"
export * from "./LandingViewTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2899a7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
installComponents(component, {VApp})
